module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "magazine-new"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/magazines"
    }
  }, [_vm._v(_vm._s(_vm.$t('Magazine List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Magazine New')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Magazine New')))]), (!_vm.savingFlag) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("タイトル")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.magazine.magazine_title),
      expression: "magazine.magazine_title"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.magazine_title
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": _vm._s(_vm.magazine.magazine_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.magazine.magazine_title = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.magazine_title),
      expression: "!validation.magazine_title"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("年月")]), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.magazine_ym_y),
      expression: "magazine_ym_y"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        _vm.magazine_ym_y = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.getMagazineYm]
    }
  }, _vm._l((_vm.getMagazineYears), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }))]), _c('label', {
    staticClass: "col-sm-1",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_vm._v("年")]), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.magazine_ym_m),
      expression: "magazine_ym_m"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        _vm.magazine_ym_m = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.getMagazineYm]
    }
  }, _vm._l((12), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }))]), _c('label', {
    staticClass: "col-sm-1",
    staticStyle: {
      "padding-top": "7px"
    }
  }, [_vm._v("月")])]), _c('hr'), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("サムネイル")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    attrs: {
      "id": "magazine_picture",
      "type": "file",
      "accept": ".jpg,.jpeg,image/jpeg,.png,image/png"
    },
    on: {
      "change": function($event) {
        _vm.selectedMagazinePicture(arguments[0])
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.magazine_picture),
      expression: "!validation.magazine_picture"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("社内報PDF")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    attrs: {
      "id": "magazine_pdf",
      "type": "file",
      "accept": ".pdf,application/pdf"
    },
    on: {
      "change": function($event) {
        _vm.selectedMagazinePdf(arguments[0])
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.magazine_pdf),
      expression: "!validation.magazine_pdf"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.onClickCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])]) : _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("保存中...")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c828e06!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/magazine-new.pug
// module id = 842
// module chunks = 1